import { Navigate } from 'react-router-dom';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PaidIcon from '@mui/icons-material/Paid';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import ReportIcon from '@mui/icons-material/Report';
import { Card } from '@mui/material';
import AppLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
import LoginPage from './pages/login';
import Page404 from './pages/Page404';
import WithdrawPage from './pages/withdraw';
import { StatementPage, LogPage, WalletPage } from './pages/account';
import { RevenuePage, ReconciliationPage } from './pages/report';
import DepositPage from './pages/deposit';

// 服务器api地址
export const serverURL = 'https://merchantapi.doudoupays.com/merchant';;

// 登录页面
export const loginPath = `/login`;

// 主页
export const mainPath = '/';

export const isRelease = () => true;

// 路由组件
export const navConfig = [
  {
    title: '账户',
    icon: <AccountBalanceIcon />,
    path: `/account`,
    items: [
      { title: '钱包', path: '/wallet', },
      { title: '帐变', path: '/statement', },
      { title: '日志', path: '/log', },
    ],
  },
  {
    title: '存款',
    icon: <AddShoppingCartIcon />,
    path: `/deposit`,
  },
  {
    title: '提款',
    icon: <PaidIcon />,
    path: `/withdraw`,
  },
  {
    title: '报表',
    icon: <ReportIcon />,
    path: '/report',
    items: [
      { title: '收益', path: '/revenue', },
      { title: '对账', path: '/reconciliation', },
    ],
  },
];

function Element({ component }) {
  return (
    <Card sx={{ margin: 1 }}>
      {component}
    </Card>
  );
}

export const routesConfig = [
  {
    path: `${mainPath}`,
    element: <AppLayout />,
    children: [
      { element: <Navigate to={'/account/wallet'} />, index: true },
      { path: 'withdraw', element: <Element component={<WithdrawPage />} /> },
      { path: 'deposit', element: <Element component={<DepositPage />} /> },
      { path: 'account/wallet', element: <Element component={<WalletPage />} /> },
      { path: 'account/statement', element: <Element component={<StatementPage />} /> },
      { path: 'account/log', element: <Element component={<LogPage />} /> },
      { path: 'report/revenue', element: <Element component={<RevenuePage />} /> },
      { path: 'report/reconciliation', element: <Element component={<ReconciliationPage />} /> },
    ],
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/',
    element: <SimpleLayout />,
    children: [
      { element: <Navigate to={'/account/wallet'} />, index: true },
      { path: `/404`, element: <Page404 /> },
      { path: '*', element: <Navigate to={`/404`} /> },
    ],
  },
  {
    path: '*',
    element: <Navigate to={`/404`} replace />,
  },
];
